import { forwardRef } from 'react';

export const UiRadio = forwardRef(function UiRadio(
  { label, className = '', style, ...inputProps },
  ref,
) {
  return (
    <label className={`ui-radio ${className}`.trim()} style={style}>
      <input {...inputProps} ref={ref} type="radio" className="ui-radio__input" />
      <span className="ui-radio__dot" aria-hidden />
      {label ? <span className="ui-radio__label">{label}</span> : null}
    </label>
  );
});
